import * as LC from '../constants/LocaleConstants';

export function countryCodeFromLocale(locale: string | undefined): string {
  switch (locale) {
    case LC.bn_BD:
    case LC.en_BD:
      return 'bd';
    case LC.en_AE:
      return 'ae';
    case LC.en_TK:
    case LC.en_TR:
    case LC.tr_TR:
      return 'tr';
    case LC.en_IN:
      return 'in';
    case LC.en_MY:
      return 'my';
    default:
      return 'uae';
  }
}

export function countryCodeFromLocaleForGa(locale: string | undefined): string {
  switch (locale) {
    case LC.bn_BD:
    case LC.en_BD:
      return 'BD';
    case LC.en_AE:
      return 'UAE';
    case LC.en_TK:
    case LC.en_TR:
    case LC.tr_TR:
      return 'TR';
    case LC.en_IN:
      return 'IND';
    case LC.en_MY:
      return 'MY';
    default:
      return 'IND';
  }
}
